import promise from 'promise';
import format from 'date-fns/format';
import merge from 'lodash/merge';
import api from 'app/shared/utils/api';
import ErrorRMW from 'app/shared/model/ErrorRMW';

// model
import ListingViewStatisticsModel from 'app/shared/model/ListingViewStatistics';
import ListingCompsModel from 'app/shared/model/ListingComps';

// graphql queries
import { getCompStatsByListingAliasQuery, getCompsByListingAliasQuery } from 'app/shared/utils/graphqlUtils';

// service
import appLogger from 'app/shared/loggers/appLogger';

const formatDate = (timestamp) => {
    if (!timestamp) {
        return '';
    }

    return format(new Date(timestamp * 1000), 'MM/DD/YY');
};

const MarketingActions = {
    fetchCompStatsByListingAlias(listingAlias) {
        const query = getCompStatsByListingAliasQuery(listingAlias);

        return dispatch => dispatch(api.marketing.fetchByQuery(query))
            .then((response) => {
                const { data, errors = []} = response;

                // handle error
                if (errors.length > 0) {
                    // first error
                    const error = errors[0];
                    const { code, message } = error;

                    // some errors are ok
                    const isAcceptableErrorCode = code === 'RENT_ZESTIMATE_NOT_FOUND'
                        || code === 'PROPERTY_DETAILS_NOT_FOUND'
                        || code === 'INVALID_INPUT';

                    // if error is not acceptable
                    if (isAcceptableErrorCode === false) {
                        // log response error (not user fiendly)
                        appLogger.logError({
                            message: `code: ${code}; message: ${message}`,
                            context: 'MarketingActions.fetchCompStatsByListingAlias',
                        });

                        // display user friendly message
                        throw new Error('No information found for this listing.');
                    }
                }

                // no response
                if (data.hasOwnProperty('byListingAlias') === false) {
                    throw new Error('No information found for this listing.');
                }

                // success
                const formattedResponse = merge(ListingViewStatisticsModel({}), data.byListingAlias);

                // format dates as String
                formattedResponse.similarFloorplans.stats.startDate =
                    formatDate(formattedResponse.similarFloorplans.stats.startDate);
                formattedResponse.similarFloorplans.stats.endDate =
                    formatDate(formattedResponse.similarFloorplans.stats.endDate);
                formattedResponse.stats.startDate = formatDate(formattedResponse.stats.startDate);
                formattedResponse.stats.endDate = formatDate(formattedResponse.stats.endDate);


                return formattedResponse;
            })
            .catch((err) => {
                appLogger.logError({
                    message: err.message,
                    context: 'MarketingActions.fetchListingByListingAlias',
                });

                return promise.reject(ErrorRMW(err));
            });
    },

    fetchCompsByListingAlias(listingAlias) {
        const query = getCompsByListingAliasQuery(listingAlias);

        return dispatch => dispatch(api.marketing.fetchByQuery(query))
            .then((response) => {
                const { data, errors = []} = response;

                // handle error
                if (errors.length > 0) {
                    // first error
                    const error = errors[0];
                    const { code, message } = error;
                    // some errors are ok
                    const isAcceptableErrorCode = code === 'RENT_ZESTIMATE_NOT_FOUND'
                        || 'PROPERTY_DETAILS_NOT_FOUND';

                    // if error is not acceptable
                    if (isAcceptableErrorCode === false) {
                        throw new Error(message);
                    }
                }

                // no response
                if (data.hasOwnProperty('byListingAlias') === false) {
                    throw new Error('No information found for this listing.');
                }

                // success
                return merge(ListingCompsModel({}), data.byListingAlias);
            })
            .catch((err) => {
                appLogger.logError({
                    message: err.message,
                    context: 'MarketingActions.fetchListingByListingAlias',
                });

                return promise.reject(ErrorRMW(err));
            });
    },
};

export default MarketingActions;
